import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { DateTime } from 'luxon'
import { useRouter } from 'next/router'
import React, { useContext } from 'react'
import { HitsProvided } from 'react-instantsearch-core'
import { DEFAULT_CONFERENCE_SLUG } from 'src/lib/apolloClient'
import getCFHCalendarUrl from 'src/lib/utils/getCFHCalendarUrl'
import getCFHVideoUrl from 'src/lib/utils/getCFHVideoUrl'

import { Theme } from '../../lib/theming/Theme'
import { TimezoneContext } from '../timezone/TimezoneProvider'
import TimeslotGroup from './TimeslotGroup'

export type TimeslotSearchHit = {
  _tags: Array<string>
  calendar_event_id?: string
  channel?: {
    url?: string
  }
  conference_topics: Array<{ id: string; name: string }>
  ends_at: string
  format?: string
  id: string
  location: { id: string; name: string }
  objectID: string
  slug: string
  starts_at: string
  timeslot_participations: Array<{
    attendance_id: string
    avatar_urls?: {
      large?: string
      medium?: string
      original?: string
      thumb?: string
      tiny?: string
    }
    company_name?: string
    id: string
    job_title?: string
    name: string
  }>
  title: string
}

const useStyles = makeStyles<Theme>(({ spacing, breakpoints }) => ({
  root: {
    padding: spacing(2, 1),
    [breakpoints.up('md')]: {
      padding: spacing(4),
    },
  },
}))

const ScheduleHits = ({ hits }: HitsProvided<TimeslotSearchHit>) => {
  const classes = useStyles()
  const router = useRouter()

  const eventSlug = (router?.query?.conferenceSlug as string) || DEFAULT_CONFERENCE_SLUG

  const { activeTimezone } = useContext(TimezoneContext)

  const timeslots = hits.map(
    ({
      calendar_event_id: calendarEventId,
      channel,
      conference_topics: topics,
      ends_at: endsAt,
      format,
      slug,
      id,
      location,
      _tags,
      starts_at: startsAt,
      timeslot_participations: timeslotParticipations,
      title,
    }) => ({
      endsAt: DateTime.fromISO(endsAt, { zone: activeTimezone.value }),
      format,
      id,
      liveURL:
        channel?.url ||
        (calendarEventId &&
          getCFHCalendarUrl({
            calenderId: calendarEventId,
            slug: eventSlug,
          })) ||
        '',
      location,
      participants: timeslotParticipations.map(
        ({
          company_name: companyName,
          attendance_id: attendanceId,
          name,
          job_title: jobTitle,
          avatar_urls: avatarUrls,
        }) => ({
          avatarUrl: avatarUrls?.thumb,
          companyName,
          id: attendanceId,
          jobTitle,
          name,
        })
      ),
      slug,
      startsAt: DateTime.fromISO(startsAt, { zone: activeTimezone.value }),
      tags: _tags,
      title,
      topics,
      videoURL: getCFHVideoUrl(id, eventSlug, endsAt),
    })
  )
  return (
    <Grid container classes={{ root: classes.root }} direction="column" justify="space-between">
      <TimeslotGroup timeslots={timeslots} />
    </Grid>
  )
}

export default ScheduleHits
